export default __webpack_public_path__ + "static/media/block_audio.11dd8fa8.svg";